import React from "react";
import {ScreenComponent} from "../../app/components/screen/ScreenComponent";
import {GradientHeaderComponent} from "../../app/components/gradientheader/GradientHeaderComponent";
import {H3SectionComponent} from "../../app/components/section/SectionComponent";

export default function ITResumeScreen() {
    return (<ScreenComponent>
        <Header/>
        <WriteOwn/>
        <NoBuzzwords/>
        <WordingMatters/>
        <Formatting/>
        <SectionsToInclude/>
        <Results/>
        <WantNotHave/>
        <CustomizeToJob/>
        <NoPronouns/>
    </ScreenComponent>)
}

function Header() {
    return (<GradientHeaderComponent title="Resume Tips"/>)
}

function WriteOwn() {
    return (<H3SectionComponent header="You are the best person to write your resume." removeTopPadding={true}>
        <p>Do not pay someone else to write it for you or help fix it. Sure, ask a friend to proofread it, compare
            it to others, but don't just copy and paste.</p>
    </H3SectionComponent>)
}

function NoBuzzwords() {
    return (<H3SectionComponent header="Don't just use buzzwords.">
        <p>Algorithms are looking at resumes, but they are looking for "Java", "Integrated Testing", etc. They
            are <i>not</i> searching for "spearheaded", "plethora", etc. Adding in those unnecessary buzzwords can
            take up precious real estate as you resume should typically be limited to 1 page (maybe 2 for
            experienced developers).</p>
    </H3SectionComponent>)
}

function WordingMatters() {
    return (<H3SectionComponent header="However, wording does still matter.">
        <p>Saying something like, "Drove cross-functional outcomes with UX designers, backend engineers, and iOS
            engineers to create a consistent and scalable user experience across various applications," is typically
            more impactful than, "Worked on Project Name with a full-stack team."</p>
    </H3SectionComponent>)
}

function Formatting() {
    return (<H3SectionComponent header="No special formatting.">
        <p>Like I mentioned, there is a lot of non-humans looking at your resume. Make it easy for the bots to
            understand it. As a general rule of thumb, I would avoid multiple columns, having lots of whitespace
            characters, and special page breaks.</p>
    </H3SectionComponent>)
}

function SectionsToInclude() {
    return (<H3SectionComponent
        header="Include the following sections: Language, Skills, Experience, Leadership & Certifications/Awards, Education. Optionally, About Me.">
        <ul>
            <li>Languages and Skills should be <i>highly</i> scannable, with no extra buzzwords. Do <i>not</i> put
                proficiency levels. Let certifications provide proficiency levels, do not rate yourself.
            </li>
            <li>If you are early in your career, you can probably remove the "Leadership & Certifications/Awards"
                section, you probably won't have enough for it to be in its own section.
            </li>
            <li>After your first engineering job, do not include your GPA, or too many details about your education.
                They aren't going to care about your Capstone projects after you have had real world experience,
                keep it just to a sentence or two, or maybe consider cutting it completely - especially if you are
                moving past one (1) page.
            </li>
            <li>About Me is weirdly controversial. Some will argue it's reason for them to not hire you - or
                additional ways for bias to be added into the mix. Others argue it's great for differentiating
                yourself from others. I have personally landed on the side of, if I need it for formatting reasons -
                to make it a full page, or make the second page worth while, I'll add it, otherwise, I'll omit it.
                Definitely be careful about what you put here, saying you enjoy watching Hockey is all fun and
                games, but saying "I'll never miss a single Maple Leafs game" is a bit dicey - may seem like your
                inflexible.
            </li>
        </ul>
    </H3SectionComponent>)
}

function Results() {
    return (<H3SectionComponent header="Put a lot of thought into results.">
        <p>Companies want to know the <i>impact</i> you've made, not what you've been assigned to do. Even if you
            don't have quantifiable things (i.e.: Increased revenue by 15%), it's still worth trying to think
            through what changed as a result of you doing X (i.e.: Generated a personalized user experience powered
            by X, and Y by doing ABC"). Here, the impact you made was allowing users to have a personalized
            experience by working on feature ABC with data X and Y. Think creatively here - <strong>DO NOT MAKE UP
                STUFF</strong>, but expand your horizons of what a result is. Revenue increase, app store rating
            increase, quicker code reviews, improved team/client satisfaction, reduced bug reports, etc. are all great
            ways to talk about results without specific data points.</p>
    </H3SectionComponent>)
}

function WantNotHave() {
    return (<H3SectionComponent header="Make sure your resume is targeting the job you WANT not the job you HAVE.">
        <p>Another mistake I see people make is writing your resume with a focus on mid-level items because that is
            your current level, when you are trying to get Senior at the next company. You may not be a "leader"
            right now, but think about any leadership skills you've done as a mid-level that can be used to put you
            in a senior-level light. Again, do not make things up, but even if you've mentored a single person, or
            led a single feature, write that down.</p>
    </H3SectionComponent>)
}

function CustomizeToJob() {
    return (<H3SectionComponent header="Make slight changes to your resume for each job you are applying to.">
        <p>If you are a full-stack developer, but the job is looking for strictly backend. Highlight the backend
            work - maybe add more detail there, even. If you are an Android dev, and it is clear the company is
            looking for Jetpack Compose devs, make sure that is listed near the top - potentially even remove XML if
            you don't think it's necessary. Look at the job listing, and make sure you've hit on the majority of it
            in your resume. Resumes take time, hours even. If you find you've "applied to hundreds, but haven't
            heard back from one" ask if you've put in the time for that specific job. If the answer is no, do
            better.</p>
    </H3SectionComponent>)
}

function NoPronouns() {
    return (<H3SectionComponent header="Avoid pronouns when describing your experiences.">
        <p>Don't put "I worked on project..." just say "Worked on..."</p>
    </H3SectionComponent>)
}
